import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * SAYFA GEÇİŞİNDE KAYBOLMAYAN EKRAN AYARI.
 *
 * ⚠️ NEDEN GEREKLİ: panoda filtre/sıralama/dönem/sayfa seçilip bir işe girilince
 *    ekran unmount oluyor, geri dönüldüğünde HER ŞEY BAŞA DÖNÜYORDU. 976 kayıtlık
 *    gerçek veride bu şu demek: 7. sayfada bulduğu işi açan kullanıcı, geri
 *    döndüğünde 1. sayfada ve filtresiz bir listeyle karşılaşıyor — aynı işi
 *    yeniden aramak zorunda. Arka arkaya birkaç işe bakmak, aramayı her seferinde
 *    tekrarlamak demekti (kullanıcı isteği 05.08.2026).
 *
 * ⚠️ `sessionStorage`, `localStorage` DEĞİL. Ayar SEKME ÖMRÜ boyunca yaşar:
 *    kullanıcının istediği "gidip geri gelince aynı kalsın"dır, "yarın sabah
 *    açtığımda hâlâ geçen ayın filtresinde olayım" değil. Kalıcı depolama, boş
 *    görünen bir panonun sebebini üç gün önceki bir tıklamaya bağlardı —
 *    teşhis edilemeyen bir "veri yok" şikâyeti üretirdi.
 *
 * ⚠️ Depolama YAZILAMAYABİLİR (Safari gizli sekme, kota dolu, kurumsal politika).
 *    Her erişim try/catch içinde ve hata yutuluyor: ekran ayarı uğruna ekranın
 *    kendisi çökmemeli. O durumda kanca sıradan `useState` gibi davranır.
 */

const ONEK = 'mod-ekran:';

function oku<T>(anahtar: string, baslangic: T): T {
  try {
    const ham = sessionStorage.getItem(ONEK + anahtar);
    if (ham == null) return baslangic;
    return JSON.parse(ham) as T;
  } catch {
    // Bozuk/okunamayan değer varsayılana düşer — kullanıcıyı kilitlemez.
    return baslangic;
  }
}

export function useKaliciDurum<T>(anahtar: string, baslangic: T) {
  // Başlangıç YALNIZ ilk render'da okunur; sonraki render'larda depolamaya
  // dönmek, kullanıcının o an yaptığı seçimi eski değerle ezerdi.
  const [deger, setDeger] = useState<T>(() => oku(anahtar, baslangic));

  const anahtarRef = useRef(anahtar);
  anahtarRef.current = anahtar;

  useEffect(() => {
    try {
      sessionStorage.setItem(ONEK + anahtarRef.current, JSON.stringify(deger));
    } catch {
      // Kota/izin hatası sessizce geçilir — bkz. yukarıdaki gerekçe.
    }
  }, [deger]);

  return [deger, setDeger] as const;
}

/**
 * Bir ekranın TÜM kalıcı ayarlarını siler.
 *
 * Çıkışta çağrılır: ortak kullanılan saha telefonunda çıkış yapıp giren kişi,
 * öncekinin filtresiyle açılmış bir pano görmemeli — `sw.ts`'teki önbellek
 * temizliğiyle aynı gerekçe.
 */
export function kaliciDurumlariTemizle() {
  try {
    const silinecek: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const a = sessionStorage.key(i);
      if (a?.startsWith(ONEK)) silinecek.push(a);
    }
    for (const a of silinecek) sessionStorage.removeItem(a);
  } catch {
    /* yok sayılır */
  }
}
